import { DataTablesModule } from 'angular-datatables';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnrolAnalyticsComponent } from './enrol-analytics/enrol-analytics.component';
import { RegistrationAnalyticsComponent } from './registration-analytics/registration-analytics.component';
import { QuizAnalyticsComponent } from './quiz-analytics/quiz-analytics.component';
import { PaymentAnalyticsComponent } from './payment-analytics/payment-analytics.component';
import { IndexAnalyticsComponent } from './index-analytics/index-analytics.component';
import { BarChartRegistrationComponent } from './bar-chart-registration/bar-chart-registration.component';



@NgModule({
  declarations: [
    BarChartRegistrationComponent,
    EnrolAnalyticsComponent, 
    RegistrationAnalyticsComponent, 
    QuizAnalyticsComponent, 
    PaymentAnalyticsComponent, 
    IndexAnalyticsComponent
   
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    HttpClientModule,
    DataTablesModule,
  ]
})
export class AnalyticsModule { }
